import { SupportTicketRegion, SupportTicketSummary } from './general-types/support-ticket';

const COUNTRY_LABELS: Record<string, string> = {
  US: 'United States',
  GB: 'United Kingdom',
  IE: 'Ireland',
};

export const SUPPORT_REGION_FILTER_OPTIONS: {
  value: SupportTicketRegion | 'all';
  label: string;
}[] = [
  { value: 'all', label: 'All regions' },
  { value: 'us', label: '🇺🇸 United States' },
  { value: 'uk_ie', label: '🇬🇧🇮🇪 UK & Ireland' },
];

export function normalizeSupportCountryCode(code: unknown): string | null {
  const normalized = String(code ?? '')
    .trim()
    .toUpperCase();
  if (!normalized) {
    return null;
  }
  if (normalized === 'UK') {
    return 'GB';
  }
  return normalized;
}

export function supportCountryFlag(code: unknown): { emoji: string; label: string } | null {
  const normalized = normalizeSupportCountryCode(code);
  if (!normalized || !/^[A-Z]{2}$/.test(normalized)) {
    return null;
  }

  const emoji = String.fromCodePoint(
    ...[...normalized].map((char) => 0x1f1e6 - 65 + char.charCodeAt(0)),
  );

  return {
    emoji,
    label: COUNTRY_LABELS[normalized] ?? normalized,
  };
}

export function ticketCountryCode(
  ticket: Pick<SupportTicketSummary, 'countryCode'> & {
    user?: { countryCode?: string | null } | null;
  },
): string | null {
  return (
    normalizeSupportCountryCode(ticket.countryCode) ??
    normalizeSupportCountryCode(ticket.user?.countryCode)
  );
}

export function supportCountryFlagForTicket(
  ticket: Pick<SupportTicketSummary, 'countryCode'> & {
    user?: { countryCode?: string | null } | null;
  },
): { emoji: string; label: string } | null {
  return supportCountryFlag(ticketCountryCode(ticket));
}

export function formatSupportCountry(code: unknown): string {
  const flag = supportCountryFlag(code);
  if (!flag) {
    const fallback = String(code ?? '').trim();
    return fallback || '—';
  }
  return `${flag.emoji} ${flag.label}`;
}
